const en = {
  base: {
    producer: 'Producer',
    factory: 'Factory',
    dealer: 'Dealer',
    customer: 'Customer',
    name: 'Name',
    admin: 'Administrator',
    username: 'Username',
    password: 'Password',
    password2: 'Confirm Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    email: 'Email',
    title: ' device maintenance',
    systemError: 'System error, please contact relevant personnel to check',
    noSession: 'No login information, please log in again',
    noParam: 'Please fill in the correct parameters',
    index: 'Home page',
    columnIndex: 'Index',
    info: 'Prompt',
    confirm: 'Confirm',
    cancel: 'Cancel',
    search: 'Search',
    edit: 'Edit',
    new: 'New',
    del: 'Del',
    save: 'Save',
    success: 'Success',
    fail: 'Fail',
    refreshSuccess: 'Refresh successful',
    saveSuccess: 'Successfully saved',
    bindSuccess: 'Binding successful',
    unbindSuccess: 'Unbind successfully',
    delSuccess: 'Successfully deleted',
    editFail: 'Modification failed',
    beginTime: 'Begin Time',
    endTime: 'End Time',
    beginDate: 'Start Date',
    endDate: 'End Date',
    opt: 'Operate',
    power: 'Power',
    on: 'On',
    pause: 'Pause',
    off: 'Off',
    clear:'Clear',
    enabled: 'Enabled',
    disabled:'Disabled',
    reboot: 'Reboot',
    refresh: 'Refresh',
    detail: 'Detail',
    choose: 'Select',
    online: 'Online',
    offline: 'Offline',
    unknow: 'Unknown',
    none: 'None',
    city: 'City',
    model: 'Model',
    date: 'Date',
    month: 'months',
    searchError: 'Query failed',
    to: 'to',
    timeInterval: 'Time interval',
    requireTimeInterval: 'Please enter the query time range',
    outerTemp: 'Outdoor temperature',
    outerHumid: 'Outdoor humidity',
    export: 'Export',
    reset: 'Reset',
    update: 'Upgrade',
    second: 'seconds',
    minute: 'minute',
    minutes: 'minutes',
    hour: 'hour',
    number: 'Number',
    rank: 'Ranking',
    mobile: 'Mobile',
    level: 'Level',
    compare: 'Compare',
    createdtime: 'Creation time',
    plantime: 'Appointment time',
    runtime: 'Run time',
    uploadTime: 'Upload time',
    uploadFile: 'Upload file',
    upload: 'Upload',
    download: 'Download',
    import: 'Import',
    selectImportFile: 'Select import file',
    tempDownload: 'Template download',
    status: 'Status',
    finish: 'Finish',
    process: 'In progress',
    startImport: 'Start importing',
    errorDesc: 'Error description',
    summary: 'Summary',
    rate: 'Proportion',
    remark: 'Remark',
    back: 'Back',
    known: 'Already known',
    floor: 'Floor',
    room: 'Room',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    yesterday: 'Yesterday',
    today: 'Today',
    clock: 'o\'clock',
    total: 'Total',
    tai: '',
    ge: '',
    and: 'And',
    or: 'Or',
    baseInfo: 'Base information',
    greater: 'greater than',
    less: 'less than',
    equal: 'equal to',
    notequal:'not equal to',
    cfgver:'Version',
    collection:'collection',
    group:'Group',
    tag:'Tag',
    newtag:'New tag',
    image:'Image',
    view:'View'
  },
  login: {
    username: 'Please enter the user name',
    password: 'Please enter the password',
    type: 'Type',
    producer: 'Producer',
    factory: 'Factory',
    dealer: 'Dealer',
    login: 'Login',
    requireMessage: 'Please enter username and password',
    noPermission: 'No platform permissions',
    passwordError: 'Incorrect username or password'
  },
  index: {
    logoff: 'Log out',
    personSet: 'Personal settings',
    changePassword: 'Personal settings',
    resetPassword: 'Reset password',
    dashboard: 'Dashboard',
    overview: 'Overview',
    customer: 'Customer',
    customerList: 'Customer List',
    feedback: 'Feed back',
    device: 'Equipment',
    deviceNo: 'Device No.',
    deviceEdit: 'Edit device',
    gatewayList: 'Gateway list',
    gatewayUpdate: 'Gateway upgrade',
    deviceList: 'Device list',
    deviceCamp: 'Device compare',
    gatewayDetail: 'Gateway detail',
    firmwareUpdate: 'Firmware upgrade',
    batchUpdate: 'Batch upgrade',
    deliver: 'Deliver',
    errorList: 'Current error device',
    errorDetail: 'Error Detail',
    errTime: 'Error push set',
    firmware: 'Firmware',
    import: 'Binding import',
    SIM: 'SIM',
    simList: 'SIM list',
    log: 'Log',
    optHistory: 'Operation log',
    errHistory: 'Error log',
    dealer: 'Dealer',
    dealerList: 'Dealer list',
    newDealer: 'New dealer',
    editDealer: 'Edit dealer',
    factory: 'Factory',
    factoryList: 'Factory list',
    Fee: 'Fee',
    recharge: 'Recharge',
    rechargeHistory: 'Recharge history',
    setup: 'System setup',
    systemParam: 'System parameter',
    staff: 'Staff management',
    staffList: 'Staff list',
    role: 'Role management',
    roleList: 'Role list',
    newRole: 'New role',
    editRole: 'Edit role',
    setupPermission: 'Permission assignment',
    warningRole: 'Equipment warning rules',
    warningRoleEdit: 'Rule edit',
    warningDevice:'Warning device',
    dealerRoleList:'Dealer Role',
    newDealerRole:'New role',
    editDealerRole: 'Edit role',
    protocolSetup:'Protocol setup',
    editStaff:'Edit Staff',
    newStaff:'Add Staff',
    SMS:'SMS',
    SMSRecharge:'SMS Recharge',
    Document:'Document',
    DocumentGroup:'Document Group',
    CreateDocument:'Edit Document',
    Mind:'Fault mind map'
  },
  welcome: {
    welcome: 'Welcome to '
  },
  notFound: {
    notFound: 'The page is building...'
  },
  device: {
    newProjectName: "new project's name",
    newProjectAddress: "new project's address",
    gatewayNo: 'Gateway No.',
    gatewayOnline: 'Gateway online',
    flowLeft: 'Flow left（MB）',
    simExpireTime: 'Sim expire time',
    protocol: 'Protocol',
    batchSetup: 'Batch setup',
    batchSetupSuccess: 'Batch settings successful',
    firmwareVersion: 'Firmware version',
    newVersion: 'New firmware version can be upgraded',
    updating: 'Upgrading',
    simSet: '4G Package',
    set: 'Package',
    flowused: 'Flow used',
    reset: 'Reset',
    lnglat: 'Lnglat positioning',
    rate: 'signal',
    gatewayLnglat: 'Gateway positioning',
    addressInfo: 'Address information',
    chooseOneGeteway: 'Please select the gateway that needs to be set up',
    chooseOneDealer: 'Please select the dealer to be assigned',
    updateTips: 'The upgrade process takes approximately 30 seconds, and after the upgrade is completed, the list needs to be manually refreshed to display the new version number',
    gatewayUpdate: 'Gateway firmware upgrade',
    gatewayUpdateFail: 'Firmware upgrade failed',
    firmwareUpdate: 'Firmware upgrade',
    deliveDealer: 'Assign dealers',
    autoReset: 'Error automatic reset',
    autoResetTip: 'After enabling automatic reset, when a fault occurs, it will automatically send a reset command twice within the set time',
    autoResetTime: 'Automatic reset time',
    autoResetTimeTip: 'After modifying the time, the automatic reset function will be automatically activated',
    deviceSummary: 'Equipment Overview',
    webOff: 'Web connection interrupted',
    offLineAlert: 'Attention! The current gateway is offline, all data is the last cached online data, not real-time!',
    projectName: 'Project',
    address: 'Address',
    customerPhone: "Customer's phone",
    srcaddress: 'srcaddress',
    deviceNo: 'Device No.',
    deviceError: 'Equipment failure',
    deviceOnline: 'Equipment status',
    tab_setupParam: 'Set parameters',
    tab_runParam: 'Parameters',
    tab_elec: 'Electricity analysis',
    tab_report: 'Parameter Report',
    tab_historyError: 'Historical faults',
    tab_optLog: 'Control records',
    tab_customer: 'User management',
    tab_mibee: '4G Gateway',
    tab_timing: 'Timing settings',
    tab_flow: 'Flow analysis',
    tab_update: 'Upgrade Log',
    saveFlowTip: 'You have not operated the page for 10 minutes. To save 4G gateway traffic, the system has been disconnected. Press F5 to refresh and restore the connection.',
    changeSort: 'Adjust sorting',
    noSupportReset: 'This device does not support reset operation',
    yesterdayPowerused: "Yesterday's energy consumption",
    todayPowerused: "Today's energy consumption",
    currentA: 'Current',
    currentW: 'Power',
    powerused: 'Energy consumption',
    noAcbData: 'There is no energy consumption analysis data in the project yet.',
    noErrorData: 'There are currently no fault records for the equipment.',
    noOptLog: 'There is currently no operation record for this device.',
    noCustData: 'There are currently no users bound to this gateway',
    noOfflineData: 'No online changes recorded within 15 days',
    heatpumpSelect: 'Device selection',
    paramSelect: 'Parameter selection',
    showType: 'Demonstrations',
    showToge: 'Merge display',
    showSingl: 'Individual display',
    deviceName: 'Device Name',
    errorDetail: 'Fault details',
    errorMsg: 'Fault content',
    errorTime: 'Fault time',
    resetTime: 'Reset time',
    optParam: 'Operation parameter',
    changeValue: 'Variable value',
    desc: 'Description',
    optTime: 'Operation time',
    optBy: 'Operation by',
    buildQrcode: 'Build Qrcode',
    bindTime: 'Binding time',
    unbindTime: 'Unbinding time',
    mainAccount: 'Main account',
    subAccount: 'Sub account',
    unbind: 'unbind',
    custBindQrcode: 'User binding QR code',
    Valid10Mins: 'The effective time has been set in the background',
    UnbindCustConfirm: 'Confirm unbound account',
    updatedVersion: 'Upgrade version',
    unknowVersion: 'unknown version',
    updateTime: 'Upgrade time',
    result: 'Result',
    notStartVersionUpdate: 'Upgrade not started',
    updateVersionSuccess: 'Upgrade Successful',
    noNeedUpdateVserion: 'It is already the latest and does not need to be upgraded',
    updateVersionOffline: 'Upgrade failed, device offline',
    updateVersionFial: 'Upgrade failed',
    updateVersionUnkonow: 'Unknown result',
    changeProtocol: 'Protocol Change',
    heatpumpVersionUpdate: 'Device firmware upgrade',
    rebootGateway: 'Restart gateway',
    updateInBackGround: 'Background upgrade in progress',
    gatewayNoNeedUpdate: 'The latest version or gateway is not online',
    reportInterval: 'Data collection interval',
    reportTime: 'Data collection time',
    gatewayLog: 'Gateway offline recording',
    updatedTime: 'Change date',
    selectOneVersion: 'Please select a firmware version first',
    refreshWebAfterUpdate: 'Firmware upgrade completed, refresh page to obtain new version number',
    chooseProtocol: 'Please select the changed protocol',
    noProtocolChange: 'The protocol remains unchanged and does not require any changes',
    changeProtocolConfirm: 'Change protocol, server data will be initialized, confirm to continue?',
    bindDealer: 'Bind dealers',
    bindGateway: 'Bind gateway',
    requireDeviceNo: 'Please enter the number',
    requireDealer: 'Please select a dealer',
    requireGateway: 'Please select a gateway',
    sofewareVersion: 'Software version',
    paramCompareList: 'Parameter Comparison List',
    max5Compare: 'Select up to 5 gateways simultaneously for comparison',
    alreadyCompare: 'Already in the comparison list',
    differentProtoComp: 'Cross protocol comparison not supported',
    choose25Compare: 'Please select 2-5 devices for comparison',
    timingHistory: 'Timed History',
    noDeviceCanBeUpdated: 'There are currently no devices to upgrade. Please make sure the device is connected to the internet.',
    currentVersion: 'Current version',
    updateProcess: 'Upgrade progress',
    chooseOneVersion: 'Select firmware version',
    updateChoosen: 'Upgrade selected items',
    createTiming: 'Create as a scheduled task',
    bookTime: 'Appointment time',
    schUpdateTime: 'Planned upgrade time',
    bookRecord: 'Appointment Record (Last 30 Days)',
    bookDeviceNumber: 'Number of reserved devices',
    selectOneDevice: 'Please select a device first',
    deviceNotMatchVersion: 'The device software version does not match the firmware version, please check',
    resetSucessInfo: 'The reset command was successfully sent, and the fault list will be queried again after 2 seconds',
    firmwareName: 'Firmware version name',
    firmwareVersionNumber: 'Firmware version No.',
    deviceVersion: 'Device version number',
    selectOneFirmwareFile: 'Select a firmware file',
    uploadTime: 'Uploaded time',
    selectOneProtocol: 'Please select the relevant protocol',
    requireFirmwareName: 'Please enter a version name',
    requirefirmwareVersionNumber: 'Please enter the version number',
    requirefirmwareVersionNumberInt: 'Version number must be a numeric value',
    delFirmware: 'Confirm removing firmware',
    delRule: 'Confirm removing rule',
    errorDay: 'Error date',
    ruleList: 'Rules list',
    ruleRelationship: 'Rule relationship',
    ruleRequired: 'Add at least one rule',
    ruleDpRequired: 'Please select parameter',
    ruleValueRequired: 'Please enter a value',
    cdp:'Comparison parameters',
    noPeople:'Unattended',
    noPeopleing:'Unattended',
    nopeopleTip:'After activation, please enable the unmanned function in the corresponding warning rules at the same time',
    errorAlert:'Fault SMS notification',
    ruleTimeMin:'Duration (minutes)',
    ruleTip1:'If "Comparison Parameters" is selected, the rule formula is: (Control Point - Comparison Parameters)>,<,=(Value)',
    ruleTip2:'Setting the duration to 0 means that the duration is not considered',
    noPeopleRole:'Unattended rules',
    noPeopleRole1:'To enable unmanned operation, the corresponding gateway also needs to synchronize the unmanned mode to take effect',
    noPeopleRole2:'When the unmanned gateway matches the warning rules, it will automatically send the instructions configured below',
    noPeopleRole3:'Unmanned gateways will not push fault alarms',
    reportTips:'The gateway allocates approximately 30MB of storage space, and the relationship between storage frequency and duration is for reference only',
    reportTips5:'5 seconds: Data saved for approximately 1.5 days',
    reportTips10:'10 seconds: Data saved for approximately 3 days',
    reportTips60:'1 minute: Data saved for approximately 18 days',
    reportTips1800:'30 minutes: Data saved for approximately 500 days',
    reportTipsmibee:'Set it to less than 10 minutes, the gateway will enter real-time data delivery mode, pay attention to traffic usage.',
    noGounp:'Ungrouped parameters',
    confirmDeleteError:'Confirm removing the error',
    newModel:'New model',
    displayRule:'display rule',
    displayProtocol:'Control by protocol',
    displayShow:'Display',
    displayHide:'Hide',
    displayConfig:'Display config',
    debugger:'Debug',
    debugInfo:'The function consumes a large amount of data, please pause or turn off it promptly after use'
  },
  overview: {
    custNumber: 'Number of Users',
    equipNumber: 'Gateway quantity',
    deviceNumber: 'Device quantity',
    onOffRate: 'Online offline ratio',
    dealerNumber: 'Number of dealers',
    feedbackNumber: 'User feedback not handled',
    simNumber: 'SIM card is about to expire',
    error30Number: '30 day fault volume',
    error: 'Fault',
    errnNumber: 'Failure frequency',
    custGrowReport: 'User growth curve',
    equipGrowReport: 'Online gateway growth curve',
    modelReport: 'Model statistics',
    error30type: 'High frequency of faults within 30 days',
    error30equip: 'Ranking of faulty equipment within 30 days'
  },
  customer: {
    avatar:'Avatar',
    nickname: 'Nick name',
    bindGateWay: 'Bind 4G geteway number',
    createdtime: 'Registration time'
  },
  sim: {
    simPoolInfo: 'Pool information',
    poolUserdMonth: "The current month's pool has been used",
    set: 'Package',
    poolSet: 'Pool package',
    totalFlow: 'Total flow',
    usedFlow: 'Used flow',
    resetFlow: 'Unused flow',
    simNumber: 'Total number of SIM cards',
    simActiveNumber: 'Active',
    simUnit: '',
    carrier: 'Operator',
    cardStatus: 'Card status',
    startdate: 'Activation date',
    expiredate: 'Expiration date',
    updatedtime: 'Update time',
    active: 'Force activation',
    activeSuccess: 'Activation successful, card status needs to wait for operator to synchronize',
    activeFail: 'Activation failed',
    recharge: 'recharge',
    planRecharge: 'Package recharge',
    rechargeIccid: 'ICCID',
    total: 'total',
    planName: 'Package name',
    planFlow: 'Package flow',
    price: 'price',
    rechargeUnit: 'Package unit',
    rechargeNumber: 'Number',
    amount: 'Amount',
    noIccid: 'No iccid information',
    noSetInfo: 'No renewable package information available',
    differenrSet: 'The selected SIM card package is inconsistent',
    requireSims: 'Please select the SIM card that needs to be recharged',
    noRechargeInfo: 'Incomplete recharge information'
  },
  fee: {
    totalAmount: 'Accumulated recharge amount',
    totalnumber: 'Accumulated recharge transactions',
    resetAmount: 'Current available balance',
    canInvoice: 'Invoicable amount',
    yuan: '',
    bi: '',
    rechargeHistory: 'Recharge Record',
    orderNo: 'Order No.',
    orderAmount: 'Recharge amount',
    orderTime: 'Order date',
    recharge: 'Recharge',
    pay: 'Pay',
    paySuccess: 'Payment successful',
    weChatPay: 'WeChat scanning payment',
    createdBy: 'Founder',
    finistTime: 'Payment completion time',
    status: 'Status',
    customAmount: 'Custom amount',
    paymentType: 'Payment method',
    clickBack: 'Please click to return',
    wechat: 'Wehcat Pay',
    qrcodePay: 'Payment QR code',
    requirePaymentAmount: 'Please enter the correct recharge amount and payment method'
  },
  setup: {
    baseInfo: 'Basic information',
    dealerHide: 'Dealer parameter hiding(Global)',
    custHide: 'Customer parameter showing(Global)',
    errorLevel: 'Error push level',
    step1: 'Step 1: Select device protocol',
    step2: 'Step 2: Check the parameters that need to be hidden',
    step2Error: 'Step 2: Select the error push level',
    checkHideControlParam: 'Check the hidden control parameters',
    checkHideRunParam: 'Check the hidden running parameters',
    cityTip: 'To be used for displaying outdoor weather on a large screen, just fill in the city name, such as "Hangzhou"',
    platformName: 'Platform header name',
    companyDesc: 'Company Profile',
    person: 'contacts',
    companyShort: 'Company abbreviation',
    isSMS: 'Accept alarm messages',
    phone: 'hotline',
    phoneTip: 'Will be displayed in the device alarm SMS of lower level dealers',
    email: 'Notification email',
    emailTip: 'If there is any email related business, it will be delivered to this email address. Please separate multiple email addresses with ","',
    requireName: 'Please enter a name',
    sizeLimit: 'The size of the uploaded image cannot exceed 2MB!',
    setupPermission: 'Set permissions',
    confirmDeletePermission: 'Confirm delete permission',
    confirmDeleteStaff: 'Confirm delete staff',
    role: 'Role',
    typeNewPassword: 'Please enter a new password',
    usernameCheck: 'User name cannot contain@',
    mobileCheck: 'Please enter the correct phone number',
    passwordCheck: 'Password cannot be less than 6 digits',
    password2Check: 'The two passwords entered do not match!',
    requireUsername: 'Please enter the user name',
    requireRole: 'Please select one role',
    requireSMScode: 'Please enter the verification code',
    requirePassword: 'Please enter the password',
    requireOldPassword: 'Please enter the original password',
    requireNewPassword: 'Please enter the new password',
    requirePassword2: 'Please enter the confirm password',
    staffPermissionTip: 'After adding permissions, this employee will only be able to access gateway devices with permissions. Accounts without separate permissions can access the entire device by default.',
    dealerPermission: 'Allocating dealer permissions',
    addPermission: 'Add permission',
    gatewayPermission: 'Individual gateway permissions',
    requireDealer: 'Please select the dealer or gateway number to bind first',
    duplictPermission: 'Repeated addition of the same permission filtering',
    confirmDelete: 'Are you sure to delete it?',
    platformName_en:'English name',
    allHide:'hide all',
    allShow:'show all'
  },
  dealer: {
    name: 'Dealer name',
    parent: 'Higher level',
    mainAccount: 'Main account',
    level: 'Level',
    phone: 'Telephone',
    factoryPhone: 'Factory hotline',
    short: 'Abbreviation',
    confirmDeleteAccount: 'Confirm delete account',
    cityTip: "Only fill in the city name, such as' Hangzhou '",
    invalidUsername: 'Illegal username',
    requireName: 'Please enter a name',
    confirmUnbindGateway: 'Confirm unbinding gateway',
    bindGateway: 'Gateway binding',
    permissionSet: 'Permission settings',
    basePermission: 'Basic permissions',
    allowWeb: 'Allow login to platform',
    allowMiniprogram: 'Allow login to mini programs',
    allowChild: 'Allow creation of sub dealer',
    equipment: 'Affiliated equipment',
    baseInfo: 'Basic information',
    reset: 'Equipment reset',
    role:'Parameter permissions',
    errorPush:'Error push',
    errorhide:'Error hide',
    cbind:'Validity period of QR code'
  },
  timing: {
    name: 'Timing name',
    add: 'Create Timing',
    addDeivce: 'Add device',
    repeat: 'Repeat',
    chooseRepeat: 'Please choose whether to repeat',
    runOnce: 'Only execute once',
    runRepeat: 'Repeat execution',
    runDevice: 'Run device',
    runTime: 'Run time',
    chooseRunTime: 'Select Run Time',
    dateRanger: 'Date constraint',
    timeRanger: 'Time constraint',
    dateFilter: 'Date filtering',
    timeTip: 'If the "end time" is filled in, the device will revert to the state before the scheduled start when the end time point is reached.',
    conditionTip: 'Except for the "Custom" option, the other conditions are the "And" relationship. If both "Working Day" and "Holiday" are selected, this timing will never be triggered.',
    dp: 'Control point',
    value: 'Value',
    setValue: 'set value',
    chooseDp: 'Please select an action',
    runtimeCheck: 'Please enter a run time',
    begindateCheck: 'Please enter the start date of the repeat run',
    begintimeCheck: 'Please enter the start time for repeated run',
    deviceCheck: 'Please set the device parameters correctly',
    new: 'New timing',
    edit: 'Edit timing',
    confirmWill: 'Confirm delete ',
    allweek: 'Monday to Friday',
    work: 'Working day',
    holiday: 'holidays',
    cust: 'custom',
    triggerTime: 'Trigger time',
    requireName:'Please enter the name',
    requireType:'Please select the type',
    atLeastOneDevice:'Please select at least one device'
  },
  report:{
    exit:'Exit',
    projectList:'National Project List',
    projectNumber:'Accumulated project quantity',
    deviceNumber:'Accumulated number of units',
    modelNumber:'Statistics on the number of unit models',
    runStatus:'Statistics of unit operation',
    p5top:'Top Five Provinces'
  },
  
  document:{
    newGroup:'New group',
    newLevel:'Next level group',
    newGroupName:"New group's name",
    confirmDeleteGroup:'Confirm delete group',
    confirmDeleteDocument:'Confirm delete document',
    pdfview:'view pdf',
    outurl:'External resources',
    name:'Document name',
    pdf:'PDF file',
    thirdurl:'Third party video website URL',
    delPdf:'Delete existing PDF file',
    requireName:'Please enter the name',
    requireGroup:'Please select a group',
    requireNode:'Please select a node',
    newNodeName:"New node's name",
    confirmDeleteNode:'Confirm delete node',
  }
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/en.js